<template>
  <div class="layout-menu-dialog-sider">
    <div class="input-box">
      <el-autocomplete
        ref="searchMenu"
        v-model="searchText"
        placeholder="搜索模块名称"
        popper-class="kye-popper-auto"
        value-key="label"
        clearable
        :trigger-on-focus="false"
        :fetch-suggestions="remoteMethod"
        @select="onChange">
      </el-autocomplete>
      <img src="../../images/add-file.svg" class="file-btn" @click="showGroupDialog(null)" />
    </div>
    <div class="list-box" v-clickoutside="outsideClick">
      <draggable
          ref="draggable"
          class="drag-box"
          :list="list"
          @change="onSortChange"
          v-bind="dragOptions">
        <div class="list-item"
          :class="{
            'list-item-focus': item.focus,
            'list-item-clicked': item.id === moduleGroupId,
            'list-item-draggable': +item.id !== 1
          }"
          v-for="item in list"
          :key="item.id"
          @click="handleGroupClick(item)">
          <div class="list-item-content">
            <img src="../../images/file-active.svg" class="list-item-prefix list-item-prefix-active" />
            <img src="../../images/file.svg" class="list-item-prefix list-item-prefix-unactive " />
            {{item.groupName}}
          </div>
          <el-popover trigger="manual" v-model="item.popoverShow" width="88" popper-class="layout-menu-dialog-sider-popover">
            <div style="width: 100%">
              <div class="action-item"  @click="showGroupDialog(item)"><img src="../../images/edit.svg" />重命名</div>
              <div class="action-item" @click="remove(item)"><img src="../../images/delete.svg" />删除</div>
            </div>
            <div class="list-item-suffix" slot="reference" @click.stop="showPopover(item)">
              <img src="../../images/more.svg" class="more-icon"  />
              <img src="../../images/more-hover.svg" class="more-icon-hover"  />
            </div>
          </el-popover>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
  import Clickoutside from 'element-ui/lib/utils/clickoutside'
  import draggable from 'vuedraggable'
  export default {
    directives: { Clickoutside },
    data() {
      return {
        searchText: '',
        list: [],
        options: [],
        moduleGroupId: '',
        dragOptions: {
          draggable: '.list-item-draggable',
          handle: '.list-item-draggable',
          animation: 150,
          ghostClass: 'kye-ghost'
        }
      }
    },
    components: { draggable },
    methods: {
      showGroupDialog (groupItem) {
        if (groupItem) {
          groupItem.popoverShow = false
        }
        this.$emit('add', groupItem)
      },
      remove(item) {
        this.$emit('delete', item)
      },
      outsideClick () {
        this.list.map(item => {
          item.popoverShow = false
          item.focus = false
        })
      },
      showPopover (item) {
        // item.popoverShow = true
        this.list.map(v => {
          v.popoverShow = item.id === v.id
          v.focus = item.id === v.id
        })
        item.focus = true
      },
      handleGroupClick (item) {
        this.moduleGroupId = item.id
        this.$emit('change', item)
      },
      setList (list) {
        this.list = [...list].map(item => ({...item, popoverShow: false, focus: false}))
      },
      async onSortChange () {
        this.$emit('sortChange', this.list)
      },
      onChange (item) {
        this.moduleGroupId = item.moduleGroupId
        const group = {
          id: item.moduleGroupId,
          groupName: item.moduleGroupName
        }
        this.handleGroupClick(group)
        this.searchText = ''
      },
      async remoteMethod (val, cb) {
        try {
          const res = await this.$http('system.homeModuleGroup.searchModule', {title: val, moduleType: 10})
          const options = res.map(item => {
            return {
              ...item,
              label: `${item.moduleGroupName} > ${item.vo.title}`,
              text: item.vo.title
            }
          })
          cb(options)
          // 自动选择第一行
          this.$nextTick(_ => {
            options.length && this.$refs['searchMenu'].highlight && this.$refs['searchMenu'].highlight(0)
          })
        } catch (error) {
          console.error(error)
        }
      },
    }
  }
</script>

<style lang="scss">
.layout-menu-dialog-sider {
  border: 1px solid #E9E8ED;
  border-radius: 4px;
  width: 176px;
  padding: 12px 0;
  height: 350px;
  display: flex;
  flex-direction: column;
  .input-box {
    display: flex;
    align-items: center;
    margin: 0 12px 8px;
    .file-btn {
      font-size: 14px;
      color: var(--g-color-primary);
      cursor: pointer;
      margin-left: 10px;
      display: block;
      width: 12px;
      // height: 12px;
    }
    input {
      // &::placeholder {
      //   font-size: 10px;
      // }
    }
  }

  .list-box {
    flex: 1;
    overflow-y: auto;
    color: #333333;
    font-size: 12px;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      cursor: pointer;
      border-radius: 3px;
      // background-color: #F5F7FA;
      background-color: rgba($color: #000000, $alpha: 0.4);
      border: 1px solid white;
    }

    &::-webkit-scrollbar-track {
      border: 0 solid transparent;
      background-color: #fff;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    &::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }
    .list-item {
      height: 32px;
      display: flex;
      padding: 0 12px;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      .list-item-content {
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      img {
        width: 12px;
        transform: translateY(1px);
        &.list-item-prefix {
          margin-right: 4px;
          color: #666666;
        }
      }
      .list-item-suffix {
        color: var(--g-color-primary);
        margin-left: 4px;
        visibility: hidden;
        .more-icon {
          display: block;
        }
        .more-icon-hover {
          display: none;
        }

        &:hover {
          .more-icon {
            display: none;
          }
          .more-icon-hover {
            display: block;
          }
        }
      }
      .list-item-prefix-unactive {
        display: inline-block;
      }
      .list-item-prefix-active {
        display: none;
      }
      &:hover {
        background: #F1F1F5;
        color: #FF9300;
        .list-item-suffix {
          visibility: visible;
          color: #FF9300;
        }
        .list-item-prefix-unactive {
          display: none;
        }
        .list-item-prefix-active {
          display: inline-block;
        }
      }
      &.list-item-focus{
        .list-item-suffix {
          visibility: visible;
        }
        .list-item-prefix-unactive {
          display: none;
        }
        .list-item-prefix-active {
          display: inline-block;
        }
      }
      &.list-item-clicked {
        color: #FF9300;
        .list-item-prefix-unactive {
          display: none;
        }
        .list-item-prefix-active {
          display: inline-block;
        }
      }
    }

  }
}
.layout-menu-dialog-sider-popover {
  min-width: 88px;
  padding: 2px 0px;
  .action-item {
    line-height: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333333;
    padding-left: 12px;
    cursor: pointer;
    &:hover {
      background: #EBECF0;
    }
    img {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/sider.vue